var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_58_90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55 27.5C55 12.3122 42.6878 0 27.5 0C12.3122 0 0 12.3122 0 27.5C0 42.6878 12.3122 55 27.5 55C42.6878 55 55 42.6878 55 27.5Z",
    fill: "#634AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6864 14.4043C42.8918 14.4043 43.869 15.3815 43.869 16.5868V25.7535C43.869 26.9589 42.8918 27.936 41.6864 27.936C40.4811 27.936 39.5039 26.9589 39.5039 25.7535V22.0688L29.3909 34.1393C28.6339 35.0427 27.2963 35.182 26.3695 34.4538L21.9677 30.995L15.0244 39.767C14.2763 40.7119 12.9037 40.8714 11.9587 40.1233C11.0136 39.3751 10.8541 38.0026 11.6023 37.0575L19.896 26.5813L20.0426 26.4134C20.8112 25.6218 22.0696 25.5236 22.9558 26.2199L27.4036 29.7145L36.5745 18.7694H32.5198C31.3144 18.7694 30.3372 17.7922 30.3372 16.5868C30.3372 15.3815 31.3144 14.4043 32.5198 14.4043H41.6864Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58_90"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo_small.1e2babaa4509eecfdf889a58e3b3d2a2.svg";
export { ForwardRef as ReactComponent };